<script lang="ts" setup>
import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { userUserPicStore } from "@/stores/data/user-pic";

const linkAdd = {
  text: "Add User PIC",
  url: "/data/user-pic/create",
};

const headers: Header[] = [
  { text: "User", value: "user_name" },
  { text: "Role", value: "role_name" },
  { text: "Position", value: "job_name" },
  { text: "Department", value: "department_name" },
  { text: "Vessel", value: "vessel_name" },
  { text: "ACTIONS", value: "action" },
];

const userPicStore = userUserPicStore();
const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listUnit = ref<any>([]);
const isLoading = ref(false);

const loadDataUserPic = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await userPicStore.dispatchGetAll(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listUnit.value = await userPicStore.userPics.items;
    page.value = await userPicStore.userPics.page;
    limit.value = await userPicStore.userPics.pageSize;
    totalItems.value = await userPicStore.userPics.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataUserPic();
};

const handleEdit = (userPic: any) => {
  router.push("/data/user-pic/" + userPic);
};

const handleDelete = async (userPic: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${userPic.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await userPicStore.dispatchDelete(
          userPic.id
        );
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataUserPic();
        } else {
          toast.error(message);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

loadDataUserPic();
</script>
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
      >
        <h3 class="mb-0">List Data Unit</h3>
      </div>
      <FilterTable :link="linkAdd" @searchByQuery="loadDataUserPic" />
      <div class="table-content">
        <BaseLoading v-if="isLoading" />
        <EasyDataTable
          :headers="headers"
          :items="listUnit"
          v-if="!isLoading"
          show-index
          :server-options="{
            page: page,
            rowsPerPage: limit,
          }"
          :server-items-length="totalItems"
          @update:server-options="handleServerOptionsUpdate"
          buttons-pagination
        >
          <template #item-action="props">
            <div class="d-flex gap-2">
              <button
                class="btn btn-info btn-sm text-white"
                @click="handleEdit(props.id)"
              >
                Edit
              </button>
              <button
                class="btn btn-danger btn-sm"
                @click="handleDelete(props)"
              >
                Delete
              </button>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
</template>
